import moment from "moment";
import { useEffect, useState } from "react";
import { FaCalendarAlt, FaEnvelope, FaRegBuilding } from "react-icons/fa";
import { MdLocationPin, MdPhoneInTalk } from "react-icons/md";
import { RiBillLine } from "react-icons/ri";
import { Link } from "react-router-dom";
import API from "../../utils/api";
import SocialSection from "../SocialSection";
import classes from "./Footer.module.css";
export default function Footer() {
  const currentYear = moment().format("YYYY");

  const [categories, setCategories] = useState([]);

  // useEffect(() => {
  //   async function fetchCategories() {
  //     try {
  //       const res = await API.post("/categories.php", { action: "fetch" });
  //       const cats = Array.isArray(res.data) ? res.data : res.data?.data || [];
  //       setCategories(cats.slice(0, 6));
  //     } catch (err) {
  //       console.error("Failed to fetch categories:", err);
  //     }
  //   }
  //   fetchCategories();
  // }, []);

  useEffect(() => {
    async function fetchCategories() {
      try {
        const res = await API.post("/categories.php", { action: "fetch" });
        const cats = Array.isArray(res.data) ? res.data : res.data?.data || [];
        const filteredCats = cats
          .filter((cat) => cat.categoryName !== "Uncategorized")
          .slice(0, 6);
        setCategories(filteredCats);
      } catch (err) {
        console.error("Failed to fetch categories:", err);
      }
    }
    fetchCategories();
  }, []);

  return (
    <div className="container-fluid p-0">
      <div className={classes.footerContainer}>
        <div className={classes.footerMainContent}>
          <div className={classes.footerTop}>
            <div className={classes.footerSection1}>
              <img
                src="/primecloudsystems_logo_white.webp"
                alt="Prime Cloud Systems"
                className={classes.footerLogo}
              />
              <p>
                Prime Cloud Systems delivers quality IT hardware and networking
                solutions across the USA, including laptops, desktops, servers,
                storage, memory, printers, and networking equipment.
              </p>
              <SocialSection />
            </div>

            <div className={classes.footerSection2}>
              <h4>Categories</h4>
              <ul>
                {categories.length > 0 ? (
                  categories.map((cat) => (
                    <li key={cat.id}>
                      <Link to={`/category/${cat.category_slug}`}>
                        {cat.categoryName}
                      </Link>
                    </li>
                  ))
                ) : (
                  <li>No categories found</li>
                )}
              </ul>
            </div>

            <div className={classes.footerSection3}>
              <h4>Customer Services</h4>
              <ul>
                <li>
                  <Link to="/privacy-policy">Privacy Policy</Link>
                </li>
                <li>
                  <Link to="/terms-and-conditions">Terms and Conditions</Link>
                </li>
                <li>
                  <Link to="/security-agreement">Security Agreement</Link>
                </li>
                <li>
                  <Link to="/return-policy">Return Policy</Link>
                </li>

                <li>
                  <Link to="/about-us">About Us</Link>
                </li>
                <li>
                  <Link to="/contact-us">Contact Us</Link>
                </li>
              </ul>
            </div>

            <div className={classes.footerSection4}>
              <h4>Contact Information</h4>
              <ul>
                <li className={classes.contactList}>
                  <MdPhoneInTalk />
                  <Link to="tel:+18444211258">1-844-421-1258</Link>
                </li>
                <div className={classes.contactListEnvelope}>
                  <li>
                    <div className={classes.emailIcon}>
                      <FaEnvelope />
                    </div>

                    <div className={classes.emailContent}>
                      <Link to="mailto:sales@primecloudsystems.com">
                        sales@primecloudsystems.com
                      </Link>
                    </div>
                  </li>
                </div>

                {/* <li className={classes.contactList}>
                  <MdLocationPin />
                  <Link
                    to="https://maps.app.goo.gl/ohnFbTXikeWDxuL7A"
                    target="_blank"
                  >
                    25930 Narbonne Ave UNIT 111 Lomita CA 90717 USA
                  </Link>
                </li> */}
              </ul>
            </div>
          </div>

          <div className={classes.footerBottom}>
            <h4>
              © {currentYear}{" "}
              <Link to="https://primecloudsystems.com" className={classes.link}>
                Prime Cloud Systems
              </Link>
              . All rights reserved.
            </h4>
            <img src="/payment-card.png" alt="Prime Cloud Systems" />
          </div>
        </div>
      </div>
    </div>
  );
}
